import React from 'react';
import style from 'styles/styled-components/style';
import styled from 'styled-components';

type ResultNoneType = 'search_yet' | 'search' | 'match';

const ResultNone = ({ type }: { type: ResultNoneType }) => {
	const text_mapper: Record<ResultNoneType, { title: string; desc: string }> = {
		search_yet: {
			title: '검색어를 입력하세요.',
			desc: '계정명, 키워드를 입력해 인플루언서를 검색해 보세요.',
		},
		search: {
			title: '검색 결과가 없습니다.',
			desc: '계정명의 경우 알파벳 또는 문장부호 등이 동일하게 입력되었는지 확인해 주세요.',
		},
		match: {
			title: '필터 매칭 결과가 없습니다.',
			desc: '필터를 다시 설정해주세요.',
		},
	};

	return (
		<ResultNoneBox>
			<style.Text typo="h4">{text_mapper[type].title}</style.Text>
			<style.Text typo="p">{text_mapper[type].desc}</style.Text>
		</ResultNoneBox>
	);
};

const ResultNoneBox = styled.div`
	width: 100%;
	height: 295px;
	margin-top: 16px;
	flex: 1 0;

	${({ theme }) => theme.common.flexCenter};
	flex-direction: column;
`;

export default ResultNone;
